import React from "react";
import { useSortable } from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";
import { Typography } from "../../../common";
import { GripVertical } from "lucide-react";

interface DraggableItemProps {
  id: string;
  item: string;
  isMatched: boolean;
}

const DraggableItem: React.FC<DraggableItemProps> = ({
  id,
  item,
  isMatched,
}) => {
  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
    isDragging,
  } = useSortable({ id });

  const style: React.CSSProperties = {
    transform: CSS.Transform.toString(transform),
    transition,
    touchAction: "none",
  };

  if (isMatched) {return null;}

  return (
    <div
      ref={setNodeRef}
      style={style}
      data-testid="dnd-draggable-item"
      data-dnd-id={id}
      {...attributes}
      {...listeners}
      className={`px-4 py-4 bg-white rounded-xl border-2 border-dashed cursor-grab active:cursor-grabbing mb-4 transition-all duration-200 transform hover:scale-101 ${
        isDragging ? "opacity-50 scale-110 shadow-xl" : ""
      }`}
    >
      <div className="flex items-center gap-3">
        <GripVertical className="w-5 h-5 flex-shrink-0" />
        <Typography variant="h6" weight="extrabold">
          {item}
        </Typography>
      </div>
    </div>
  );
};

export default DraggableItem;
